export enum OrderEntryIssueTypeDomestic {
    MISSING_ITEMS_LINES_DOM = 'Order Entry - Missing Items/Lines',
    P41_NOT_VALIDATED_DOM = 'Order Entry - P41 not validated',
    WRONG_MATERIAL_DOM = 'Order Entry - Wrong Material',
    PRICE_OVERRIDE_DISCOUNTED_ORDERS = 'Price Override/Discounted Orders',
    POC_PRICE_PROMO = 'POC Price Promo',
    EXPEDITE_FEE_WAIVED = 'Expedite Fee Waived',
    WRONG_ACCOUNT_DOM = 'Order Entry - Wrong Account',
    WRONG_ORDER_TYPE_DOM = 'Order Entry - Wrong Order Type',
    CUSTOMER_ORDER_ERROR_DOM = 'Customer Order Error',
    EDI_ORDERING_ISSUE_DOM = 'EDI Ordering Issue',
    MISINFORMATION_PROVIDED_COMMUNICATION_INADEQUATE_DOM = 'Misinformation Provided/Communication Inadequate',

    // Removed
    WRONG_BILL_TO_SHIP_TO_ACCOUNT_DOM = 'Order Entry - Wrong Bill-to and/or Ship-to Account',
    CUSTOMER_ORDERED_WRONG_MATERIAL_DOM = 'Customer Ordered Wrong Material',
    PLANNER_ERROR_DOM = 'Planner Error',
    REFUSED_SHIPMENT_DOM = 'Refused Shipment'
}
